/* eslint-disable no-unused-vars */
import { MASTER_DATA_KEY } from '@/constants'
import { camelCase } from 'lodash'
import { add, startOfDay } from 'date-fns'
import Utils from '@/utils'

export default {
  namespaced: true,
  state: () => ({
    ...Object.fromEntries(MASTER_DATA_KEY.map((item) => [camelCase(item), []])),
  }),
  getters: {
    deliveryServiceShop: (state) => state.deliveryServiceShop ?? [],
    desiredDeliveryDays:
      (state) =>
      (deliveryMinDate = null) =>
        [
          ...Array.from(Array(58).keys()).map((index) => {
            const date = add(startOfDay(deliveryMinDate || new Date()), {
              days: index + (deliveryMinDate ? 0 : 3), // EC-2697
            })

            return {
              value: date.getTime(),
              label: Utils.date.formatDateJP(date),
            }
          }),
        ],
  },
  mutations: {
    SET_DATA(state, data) {
      data.forEach((item) => {
        state[camelCase(item.name)] = item.data || []
      })
    },
  },
}
